/* Pediment Father's Day Sale landing — reviews pagination. */
(function () {
  var PER_PAGE = 3;

  function initReviews(root) {
    var grid = root.querySelector('.ps__rv-grid');
    var nav  = root.querySelector('.ps__rv-nav');
    if (!grid || !nav) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.ps__rv'));
    if (cards.length === 0) { nav.hidden = true; return; }

    var pages = Math.ceil(cards.length / PER_PAGE);
    if (pages <= 1) { nav.hidden = true; return; }

    var dotsHost = nav.querySelector('[data-dots]');
    var prev = nav.querySelector('[data-prev]');
    var next = nav.querySelector('[data-next]');

    for (var i = 0; i < pages; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.dataset.dot = String(i);
      dot.setAttribute('aria-label', 'Page ' + (i + 1) + ' of ' + pages);
      dotsHost.appendChild(dot);
    }

    var page = 0;

    function render() {
      cards.forEach(function (card, idx) {
        var onPage = Math.floor(idx / PER_PAGE) === page;
        card.hidden = !onPage;
      });
      nav.querySelectorAll('[data-dot]').forEach(function (dot, idx) {
        dot.setAttribute('aria-current', idx === page ? 'true' : 'false');
      });
      prev.disabled = page === 0;
      next.disabled = page === pages - 1;
    }

    prev.addEventListener('click', function () {
      if (page > 0) { page--; render(); }
    });
    next.addEventListener('click', function () {
      if (page < pages - 1) { page++; render(); }
    });
    dotsHost.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-dot]');
      if (!dot) return;
      page = Number(dot.dataset.dot);
      render();
    });

    render();
  }

  function initRandomize(root) {
    root.querySelectorAll('[data-randomize]').forEach(function (list) {
      var items = Array.prototype.slice.call(list.children);
      // Fisher-Yates shuffle, then re-append in random order.
      // CSS :nth-child(n+keep+1) handles the hide; no JS hide needed.
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = items[i]; items[i] = items[j]; items[j] = tmp;
      }
      items.forEach(function (item) { list.appendChild(item); });
    });
  }

  function initSmoothScroll() {
    // Mirrors the .ignore-smooth-scroll opt-out used by the rest of the site
    // (see assets/gem-page-*.js.liquid). Same-page anchor clicks smooth-scroll
    // to the target; off-page links and opt-outs fall through to default nav.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (!link || link.classList.contains('ignore-smooth-scroll')) return;
      var hash = link.hash;
      if (!hash || hash === '#') return;
      if (link.pathname !== window.location.pathname) return;
      if (link.protocol !== window.location.protocol) return;
      if (link.host !== window.location.host) return;
      var id = hash.slice(1);
      var target = document.getElementById(id) || document.querySelector('a[name="' + id + '"]');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Update the URL hash without re-triggering the jump.
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', hash);
      }
    });
  }

  function init() {
    document.querySelectorAll('.pediment-sale').forEach(function (root) {
      initReviews(root);
      initRandomize(root);
    });
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
